module.exports = __webpack_public_path__ + "img/wx.9c14e539.png";